export const LOGIN_REGEX = /^[A-Za-z0-9 ]*$/;
export const TITLE_COLOR = "#536dfe";
export const TITLE_FONT_SIZE = "26px";
export const TEXT_COLOR = "#172255";
export const TEXT_FONT_SIZE = "16px";
export const DEFAULT_FONT_FAMILY = "Roboto";
